// extracted by mini-css-extract-plugin
module.exports = {"inquiryLink":"InquiryLink-module--inquiry-link--21Kq6","inquiryLinkForm":"InquiryLink-module--inquiry-link-form--bbrKb"};